const LabelPackage = {
    name: 'label',
    configure: function(config) {
        config.addLabel('undo', {
            en: 'Undo',
            sv: 'Ångra'
        })

        config.addLabel('redo', {
            en: 'Redo',
            sv: 'Upprepa'
        })

        config.addLabel('save-article', {
            en: 'Save article',
            sv: 'Spara artikel'
        })

        config.addLabel('No spelling suggestions', {
            en: 'No spelling suggestions',
            sv: 'Inga stavningsförslag'
        })
        config.addLabel('select-all', {
            en: 'Select all',
            sv: 'Markera allt'
        })
        config.addLabel('paragraph', {
            en: 'Body',
            sv: 'Brödtext'
        })

        config.addLabel('emphasis', {
            sv: 'Kursiv'
        })

        config.addLabel('strong', {
            sv: 'Fet'
        })

        // --------------------------------------
        // Labels In Error and start loading pages
        // --------------------------------------

        config.addLabel('error-page-Error', {
            en: 'An error occured',
            sv: 'Något gick fel'
        })

        config.addLabel('error-page-error-description', {
            en: 'Error description',
            sv: 'Felbeskrivning'
        })

        config.addLabel('error-page-status-code', {
            en: 'Error status code',
            sv: 'Felmeddelandekod'
        })

        config.addLabel('error-page-status-url', {
            en: 'Requested URL',
            sv: 'Efterfrågad URL'
        })

        config.addLabel('error-page-human-readable-404', {
            en: 'The requested article could not be found',
            sv: 'Artikeln du försökte öppna kunde inte hittas.'
        })
        config.addLabel('error-page-human-readable-generic', {
            en: 'Could not open the requested article',
            sv: 'Kunde inte öppna artikeln.'
        })

        // --------------------------------------
        // Labels specified in API
        // --------------------------------------

        config.addLabel('message', {
            en: 'Message',
            sv: 'Meddelande'
        })

        config.addLabel('cancel', {
            en: 'Cancel',
            sv: 'Avbryt'
        })

        config.addLabel('continue', {
            en: 'Continue',
            sv: 'Fortsätt'
        })

        config.addLabel('main', {
            en: 'Meta',
            sv: 'Meta'
        })

        config.addLabel('Article not saved!', {
            en: 'Article not saved!',
            sv: 'Artikeln sparades ej!'
        })

        config.addLabel('Please wait until images are uploaded before saving.', {
            en: 'Please wait until images are uploaded before saving.',
            sv: 'Vänligen vänta tills alla bilder laddats upp innan du sparar.'
        })

        config.addLabel('Copy created. You are now working on a new unsaved copy of the original article.', {
            en: 'Copy created. You are now working on a new unsaved copy of the original article.',
            sv: 'En kopia har skapats. Du arbetar nu med en osparad kopia av den ursprungliga artikeln.'
        })

        config.addLabel('error-human-readable-conflict', {
            en: 'The article has been updated on the server. Please copy your work and reload the article.',
            sv: 'Artikeln har uppdaterats på servern. Vänligen kopiera dina ändringar och ladda om artikeln.'
        })

        config.addLabel('Article is invalid', {
            en: 'Article is invalid',
            sv: 'Artikeln går ej att spara'
        })

        config.addLabel('This article is no longer valid', {
            en: 'Article is marked invalid and can no longer be saved',
            sv: 'Artikeln är markerad som ogiltig och går ej att spara'
        })

        config.addLabel('A problem occurred', {
            sv: 'Ett problem har uppstått'
        })
    }
}

export {LabelPackage}
